// A require-context-shaped function over an explicit component registry, for
// react_ujs' `useContext`. `registry` maps a react_component name (the part
// before any `.export` suffix, for example 'WCAG/Header' or 'OnboardPortal')
// to a loader that requires the module.
const buildRegistryContext = (registry, packName) => {
  // A Map so names such as 'constructor' cannot resolve to Object.prototype members.
  const loaders = new Map(Object.entries(registry));
  const context = (request) => {
    const name = request.replace(/^\.\//, '');
    const load = loaders.get(name);
    if (!load) {
      throw new Error(
        `[${packName}] React component "${name}" is not in this pack's registry. ` +
          'Add it to app/javascript/public_rendering/ so public pages can mount it.'
      );
    }
    return load();
  };
  context.keys = () => [...loaders.keys()].map((name) => `./${name}`);
  return context;
};

export default buildRegistryContext;
